import { StyleColor } from '../../utils/styles-constants';
import { spin } from '../../utils/style';
import styled, { css } from 'styled-components';

const loader = css`
	cursor: default;
	display: flex;
	align-items: center;
	justify-content: center;

	& > :last-child {
		margin: 0 5px;
	}

	& > svg {
		position: relative;
		animation: ${spin};
	}
`;

interface LoaderProps {
	isDownloadingAll: boolean;
}

const LoaderVariants: ({}) = {
	['Button']: styled('div') `${css`
		${loader}
		& > svg {
			height: 25px;
			width: 25px;
			margin-left: ${(props: LoaderProps) => props.isDownloadingAll ? `-25px` : `0`};
			margin-right: ${(props: LoaderProps) => props.isDownloadingAll ? `15px` : `5px`};
		}
	`}`,
	['Overlay']: styled('div')`${css`
		${loader}
		background: ${StyleColor.White};
		color: ${StyleColor.Black};
		opacity: 0.9;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 4;
		border-radius: 7px;

		& > svg {
			height: 30px;
			width: 30px;
			margin-right: 5px;
		}
	`}`
};

export { LoaderVariants };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Loader/styles.ts